function ForgotPasswordCtrl($scope, authService, $stateParams, sdkUtils) {
  $scope.resetSent = false;

  $scope.forgotPasswordForm = {
    email: $stateParams.email
  };

  $scope.isLoggedIn = function () {
    return authService.isLoggedIn();
  };

  /**
   * @desc Send forgot password email for user
   * @param {Object} form - Angular form object
   * @param {Object} [$event] - Angular event object
   */
  $scope.sendForgotPasswordEmail = function (form, $event) {
    if (!form) throw new Error('form is required');
    if ($event) $event.preventDefault();

    $scope.submitted = true;

    if (!form.$valid) return;

    $scope.sending = true;
    $scope.error = null;
    $scope.submitted = false;

    authService.forgotPassword({
        email: $scope.forgotPasswordForm.email
      })
      .then(() => {
        $scope.successMessage = 'We\'ve sent a reset password link to your email. Please reset your password and try logging in again.';
      })
      .catch(response => {
        $scope.error = sdkUtils.getErrorFromResponse(response);
      })
      .finally(() => {
        $scope.sending = false;
      });
  };
}

ForgotPasswordCtrl.$inject = [
  '$scope',
  'jsSdk.auth',
  '$stateParams',
  'jsSdk.utils'
];

export default ForgotPasswordCtrl;



// WEBPACK FOOTER //
// ./src/components/forgotPassword/forgotPasswordCtrl.js